import { EmployeeTodos } from "./emp-todos/emp-todos";

export const TodosSection = () => {
  return (
    <div className="flex flex-col gap-2">
      <h1 className="text-lg font-medium tracking-wide underline underline-offset-2">
        Todos
      </h1>

      <div className="flex flex-wrap gap-6">
        <EmployeeTodos />
      </div>
    </div>
  );
};
